import React from 'react';
import { EcpApi } from '../../api';

//get point amont
export const getAmontPoint = (data: any[]) => {
  let point: any[] = [];
  data.forEach((item) => {
    if (item.typeLimitPoint === 'AMONT') {
      point.push(item);
    }
  });
  return point;
};

export const getSelectedPointAval = (data: any[]) => {
  let point: any[] = [];
  data.forEach((item) => {
    if (item.typeLimitPoint === 'AVAL') {
      point.push(item);
    }
  });

  return point;
};
//get point aval
export const getAvalPoint = (data: any[]) => {
  let point: any[] = [];
  data.forEach((item) => {
    point.push(item);
  });
  return point;
};

//get selectedPoints
export const getSelectedPoints = (
  pPointsToUpdate: any[],
  pMatrixToCompare: any[],
  pMode: string,
) => {
  let prPointsSelected: any[] = [];
  pPointsToUpdate.forEach((selectedPoint: any) => {
    const isFound = pMatrixToCompare.find(
      (prPoint: any) =>
        prPoint.mainInstallCode === selectedPoint.mainInstallCode,
    );
    if (isFound !== undefined) {
      if (pMode === 'update') {
        selectedPoint.selectedPoint = true;
      } else {
        prPointsSelected.push({
          ...selectedPoint,
          selectedPoint: true,
          id: isFound.id,
        });
      }
    }
  });
  if (pMode === 'update') {
    return pPointsToUpdate;
  } else {
    return prPointsSelected;
  }
};

//generate an array for hour
export const HourArr = () => {
  let arr: any[] = [];
  let i;
  for (i = 0; i < 24; i++) {
    arr.push({
      id: i,
      name: '' + i + '',
    });
  }
  return arr;
};

// generate an array of duration
export const DurationByHour = () => {
  let arr: any[] = [];
  let i;
  for (i = 8; i <= 24; i = i + 4) {
    arr.push({
      id: i,
      name: i + 'h',
    });
  }
  return arr;
};

//get api data
export const getRainParam = async (
  setLoading: React.Dispatch<React.SetStateAction<boolean>>,
  contractId: string,
  setPluieList: React.Dispatch<any>,
  setForm: React.Dispatch<any>,
  setError: React.Dispatch<React.SetStateAction<boolean>>,
  setTitle: React.Dispatch<React.SetStateAction<string>>,
  setErrorMessage: React.Dispatch<React.SetStateAction<string>>,
) => {
  setLoading(true);
  try {
    const response = await EcpApi.getRainParameters(contractId);
    if(response.status === 200) {
      setPluieList(response.data);
      setForm({
        id: response.data.id,
        pjMinus1: response.data.pjMinus1,
        pjMinus1PjMinus2: response.data.pjMinus1PjMinus2,
        pjMinus1High: response.data.pjMinus1High,
        minDryPeriod: response.data.minDryPeriod,
      });
    } else {
      setError(true);
      setTitle('Donnée inexistante');
      setErrorMessage(
        'Nous ne pouvons pas afficher la donnée car elle est inexistante',
      );
    }
  } catch (e) {
    console.log(e);
    setError(true);
  }
  setLoading(false);
};

// beforeSubmit function
export async function beforeSubmit(
  validation: {
    pjMinus1PjMinus2: any;
    pjMinus1High: any;
  },
  setLoading: React.Dispatch<React.SetStateAction<boolean>>,
  form: any,
  contractId: string,
  toast: React.MutableRefObject<any>,
) {
  setLoading(true);
  let isValid;
  if (validation.pjMinus1PjMinus2 != null || validation.pjMinus1High != null) {
    isValid = false;
  } else {
    isValid = true;
  }
  if (isValid) {
    try {
      const response = await EcpApi.updateRainParameters(form, contractId);
      if (response.status === 200) {
        toast.current?.show({
          severity: 'success',
          summary: 'Succès',
          detail: 'Données de paramètre enregistrées',
          life: 5000,
        });
      } else {
        toast.current?.show({
          severity: 'error',
          summary: 'Erreur',
          detail:
            "Erreur lors de l'enregistrement des données de paramètre enregistrées",
          life: 5000,
        });
      }
    } catch (e) {
      console.log(e);
      toast.current?.show({
        severity: 'error',
        summary: 'Erreur',
        detail:
          "Erreur lors de l'enregistrement des données de paramètre enregistrées",
        life: 5000,
      });
    }
  }
  setLoading(false);
}

//get api data
export const getBassin = async (
  setLoading: React.Dispatch<React.SetStateAction<boolean>>,
  setBassinData: React.Dispatch<React.SetStateAction<never[]>>,
  contractCode: string,
  setError: React.Dispatch<React.SetStateAction<boolean>>,
  setTitle: React.Dispatch<React.SetStateAction<string>>,
  setErrorMessage: React.Dispatch<React.SetStateAction<string>>,
) => {
  setLoading(true);
  try {
    const response = await EcpApi.getBassin(contractCode);
    setBassinData(response.data);

    if (response.status === 200 && response.data.length < 1) {
      setError(true);
      setTitle('Donnée inexistante');
      setErrorMessage(
        'Nous ne pouvons pas afficher la donnée car elle est inexistante',
      );
    }
  } catch (e) {
    console.log(e);
    setError(true);
  }
  setLoading(false);
};

//On bassin change
export const onBassinChange = async (
  bassin: any,
  setValidation: any,
  getPoint: (pointId: any) => Promise<void>,
  getParameters: (parametersId: any) => Promise<void>,
) => {
  if (bassin !== null) {
    setValidation((values: any) => ({
      ...values,
      collectionPoolId: bassin.id ? null : 'Bassin de collecte manquant',
    }));
    getPoint(bassin.id);
    getParameters(bassin.id);
  }
};

// handleOnSubmit FormWidget function
export function handleEcpOnSubmit(setValidation: any, form: any) {
  setValidation({
    collectionPoolId: form.collectionPoolId
      ? null
      : 'Bassin de collecte manquant',
    hourPeakBegin:
      form.hourPeakBegin >= form.hourPeakEnd
        ? 'La date de début est supérieure ou égale à la date de fin'
        : null,
    hourPeakEnd:
      form.hourPeakEnd - form.hourPeakBegin > 7
        ? 'La plage horaire doit être inférieure ou égale à 7 heures'
        : null,
    ecpicoefValue:
      form.ecpicoefValue < 0 || form.ecpicoefValue > 100
        ? 'Valeur obligatoire de type pourcentage comprise entre 0 et 100'
        : null,
  });
}

// handleOnSubmit FormWidget function
export function handleIliOnSubmit(setValidation: any, form: any) {
  setValidation({
    tresholds:
      (form.verySensitiveTreshold != null &&
        form.littleSensitiveTreshold == null) ||
      (form.littleSensitiveTreshold != null &&
        form.verySensitiveTreshold == null)
        ? "Si l'un des seuils est renseigné, l'autre doit l'être également"
        : form.verySensitiveTreshold == null &&
          form.littleSensitiveTreshold == null
        ? 'Les seuils doivent être renseignés'
        : null,
    tresholdMax:
      form.littleSensitiveTreshold != null &&
      (form.verySensitiveTreshold ?? -1) < form.littleSensitiveTreshold
        ? 'Le seuil très sensible doit être supérieur au seuil peu sensible'
        : null,
  });
}

export const savePoolPoints = async (pAvalPoints: any [], ShowToast: any) => {
  const getSelectedPoint = pAvalPoints.map((aval: any) => {
    return {
      id: aval.id,
      typeLimitPoint: aval.typeLimitPoint,
      selectedPoint: aval.selectedPoint,
    };
  });
  try {
    const response = await EcpApi.updatePoolPoints(getSelectedPoint);
    if(response.status === 200) {
      ShowToast('success', 'Succès', 'Point aval enregistré');
    } else {
      ShowToast(
        'error',
        'Erreur',
        "Erreur lors de l'enregistrement du point aval",
      );
    }
  } catch (e) {
    ShowToast(
      'error',
      'Erreur',
      "Erreur lors de l'enregistrement du point aval",
    );
  }
}

export const saveSelectedPoints = async (pPointsAmont: any[], pDoSelectd: any[], pCollectionPoolId: any, ShowToast: any) => {
  const pts: any[] = pPointsAmont.map((aval: any) => {
    return {
      collectionPoolId: pCollectionPoolId,
      mainInstallCode: aval.mainInstallCode,
      //mainInstallName: aval.mainInstallName,
    };
  });
  let doSelectedToSend: any = [];
  pDoSelectd.forEach((pool: any) => {
    if (pool.selectedPoint === true) {
      doSelectedToSend.push({
        collectionPoolId: pCollectionPoolId,
        mainInstallCode: pool.mainInstallCode,
        //mainInstallName: pool.mainInstallName,
      });
    }
  });
  try {
    //save modification on amont points and do/tp linked
    const response = await EcpApi.updateSelectedPoint(
      pCollectionPoolId,
      pts.concat(doSelectedToSend),
    );
    if (response.status === 200) {
      ShowToast('success', 'Succès', 'Points amont et/ou DO associés enregistrés');
    } else {
      ShowToast(
        'error',
        'Erreur',
        "Erreur lors de l'enregistrement du point aval et/ou DO associés",
      );
    } 
  } catch (e) {
    ShowToast(
      'error',
      'Erreur',
      "Erreur lors de l'enregistrement du point aval et/ou DO associés",
    );
  }
}

export async function submit(
  form: any,
  validation: {
    tresholds: null;
    tresholdMax: null;
    collectionPoolId: null | any;
    hourPeakBegin: null | any;
    hourPeakEnd: null | any;
    ecpicoefValue: null | any;
  },
  setLoading: React.Dispatch<React.SetStateAction<boolean>>,
  ShowToast: (severity: any, summary: any, detail: any) => any,
  pointAval: any,
  pointsAmont: any,
  doSelected: any,
  setValidation: any,
) {
  handleEcpOnSubmit(setValidation, form);
  let isValid;
  if (
    form.collectionPoolId === undefined ||
    form.hourPeakBegin === undefined ||
    form.hourPeakEnd === undefined ||
    form.nbConnected === undefined ||
    form.consumption === undefined ||
    form.ecpicoefValue === undefined ||
    validation.collectionPoolId != null ||
    validation.hourPeakBegin != null ||
    validation.hourPeakEnd != null ||
    validation.ecpicoefValue != null ||
    validation.tresholdMax != null ||
    validation.tresholds != null
  ) {
    isValid = false;
  } else {
    isValid = true;
  }
  if (isValid) {
    setLoading(true);
    try {
      const response = await EcpApi.updatePoolParameters(form);  
      if (response.status === 200) {
        ShowToast('success', 'Succès', 'Données de paramètres enregistrées');
        savePoolPoints(pointAval, ShowToast);
        saveSelectedPoints(pointsAmont, doSelected, form.collectionPoolId, ShowToast);
      } else {
        ShowToast(
          'error',
          'Erreur',
          "Erreur lors de l'enregistrement des données de paramètre enregistrées",
        );
      }
    } catch (e) {
      ShowToast(
        'error',
        'Erreur',
        "Erreur lors de l'enregistrement des données de paramètre enregistrées",
      );
    }
    setLoading(false);
  }
}

// mapping for points pr for dropdownlist
export const mapPointPr = (points: any[], pMode?: boolean) => {
  return points.map((pr: any, index: number) => ({
    id: index,
    mainInstallName:
      pr.mainInstallLabel !== undefined
        ? pr.mainInstallLabel
        : pr.mainInstallName,
    mainInstallCode: pr.mainInstallCode,
    typeLimitPoint: 'AMONT',
    selectedPoint: pMode !== undefined ? pMode : pr.selectedPoint,
  }));
};

export const avoidDupplicate = (data: any[]) => {
  const newData: any[] = [];
  data.forEach((dataPt) => {
    const avoidDupplicate = newData.find(
      (newDataPt) => dataPt.mainInstallCode === newDataPt.mainInstallCode,
    );
    if (avoidDupplicate === undefined) {
      newData.push(dataPt);
    }
  });
  return newData;
};

// Définition de la fonction pour mapper les éléments
export const mapPointAval = (points: any[]) => {
  return points[0] !== undefined
    ? points.map((aval: any) => ({
        ...aval,
        id: aval.id,
        label: aval.mainInstallName,
        value: aval.mainInstallCode,
        name: aval.mainInstallName,
      }))
    : [];
};

const orderByName = (users: any[], name: string) =>
  users.sort(function (a, b) {
    if (a[name] < b[name]) {
      return -1;
    }
    if (a[name] > b[name]) {
      return 1;
    }
  return 0;
});

// getPoint FormWidget function
export const getPoint = async (
  contractId: string,
  pointId: any,
  setLoading: React.Dispatch<React.SetStateAction<boolean>>,
  setAmontPoint: React.Dispatch<any>,
  setAvalPoint: React.Dispatch<any>,
  setSelectedPointAval: React.Dispatch<any>,
  setSelectedPoints: React.Dispatch<any>,
  setPointAmontError: React.Dispatch<any>,
  setPointAvalError: React.Dispatch<any>,
  setError: React.Dispatch<React.SetStateAction<boolean>>,
) => {
  setLoading(true);
  try {
    // get pr
    const responseAllPr = EcpApi.getInstall(contractId, 'MDI_PR');
    // amont pont already selected by user
    const response_amont_point_selected = EcpApi.getSelectedPoint(
      pointId,
    );
    // Load aval/amont points list when collectionPool has changed
    const responseAllPoints = EcpApi.getPoint(pointId);
    const [allPr, allPointsSelected, allPoints] = await Promise.allSettled([
      responseAllPr,
      response_amont_point_selected,
      responseAllPoints,
    ]);
    
    let pointAvalInit, prPoint, amontPointSelected: any[] = [];
    if (allPoints.status === 'fulfilled') {
      pointAvalInit = getAvalPoint(allPoints.value.data);
    }
    if (allPr.status === 'fulfilled') {
      prPoint = mapPointPr(allPr.value.data, false);
    }
    // get PR point and add to amont points
    if (allPointsSelected.status === 'fulfilled') {
      amontPointSelected = avoidDupplicate(
        mapPointPr(allPointsSelected.value.data, true),
      );
    }
  
    const updateSelectedStatus = getSelectedPoints(
      prPoint,
      amontPointSelected,
      'update',
    );
    const selectedPointAvalInit = getSelectedPointAval(pointAvalInit);

    // Utilisation de la fonction pour mapper pointAvalInit
    const pointAval = mapPointAval(pointAvalInit);

    const filtredSelectedPointAval = [
      selectedPointAvalInit.find((aval: any) => aval.selectedPoint === true),
    ];

    // Utilisation de la fonction pour mapper selectedPointAvalInit
    const selectedPointAval = mapPointAval(filtredSelectedPointAval);
    setAvalPoint(pointAval);
    setSelectedPointAval(selectedPointAval);
    setAmontPoint(orderByName(updateSelectedStatus, 'mainInstallName'));
    setSelectedPoints(amontPointSelected);
    setPointAmontError(
      updateSelectedStatus.length < 1 ? 'Données inexistantes' : '',
    );
    setPointAvalError(pointAvalInit.length < 1 ? 'Données inexistantes' : '');
  } catch (e) {
    setError(true);
  }
  setLoading(false);
};

//On point aval change
export const OnPointAvalChange = (
  option: any,
  pointAval: any,
  setAvalPoint: React.Dispatch<any>,
  setSelectedPointAval: React.Dispatch<any>,
) => {
  //Modification du nouveau point aval
  let pointSelected = option;
  let pointAvalUpdate = pointAval.map((item: any) => {
    if (pointSelected !== null && (item.mainInstallCode === pointSelected.mainInstallCode)) {
      item.selectedPoint = true;
      item.typeLimitPoint = 'AVAL';
    } else {
      item.selectedPoint = false;
      item.typeLimitPoint = 'AMONT';
    }
    return item;
  });
  setAvalPoint(pointAvalUpdate);
  setSelectedPointAval(pointSelected === null ? [] : [pointSelected]);
};

export const getPointAttached = async (
  contractId: any,
  installTypes: string,
  setLoading: React.Dispatch<React.SetStateAction<boolean>>,
  setDoList: React.Dispatch<any>,
  selectedPoints: any,
  setError: React.Dispatch<React.SetStateAction<boolean>>,
  setSelectedDo: React.Dispatch<any>,
) => {
  setLoading(true);
  try {
    const response = await EcpApi.getInstall(contractId, installTypes);
    const doList = response.data;
    const doListInit = mapPointPr(doList, false);
    const doListInitUpdated = getSelectedPoints(
      doListInit,
      selectedPoints,
      'update',
    );
    const doSelected = getSelectedPoints(
      selectedPoints,
      doListInitUpdated,
      'get',
    );
    setDoList(doListInitUpdated);
    setSelectedDo(doSelected);
  } catch (e) {
    setError(true);
  }
  setLoading(false);
};

//On point amont change
export const OnPointAmontChange = (
  options: any,
  setSelectedPointAmont: React.Dispatch<any>,
) => {
  setSelectedPointAmont(
    orderByName(getSelectedPoints(options.value, options.value, 'update'), 'mainInstallName'),
  );
};

//On point DO change
export const OnPointDoChange = (
  options: any,
  setSelectedDoTp: React.Dispatch<any>,
) => {
  setSelectedDoTp(getSelectedPoints(options.value, options.value, 'update'));
};

// getParameters FormWidget function
export const getParameters = async (
  parametersId: any,
  setLoading: React.Dispatch<React.SetStateAction<boolean>>,
  setForm: React.Dispatch<React.SetStateAction<any>>,
  setParamList: React.Dispatch<any>,
  setIsDoAttached: React.Dispatch<any>,
  setError: React.Dispatch<React.SetStateAction<boolean>>,
  setTitle: React.Dispatch<React.SetStateAction<string>>,
  setErrorMessage: React.Dispatch<React.SetStateAction<string>>
) => {
  setLoading(true);

  try {
    const response = await EcpApi.getPoolParameters(parametersId);
    setForm({
      id: response.data.id,
      collectionPoolId: response.data.collectionPoolId,
      collectionPoolType: response.data.collectionPoolType,
      hourPeakBegin: response.data.hourPeakBegin,
      hourPeakEnd: response.data.hourPeakEnd,
      doSelected: response.data.doSelected,
      nbConnected: response.data.nbConnected,
      consumption: response.data.consumption,
      ecpicoefType: response.data.ecpicoefType,
      ecpicoefValue: response.data.ecpicoefValue,
    });
    setParamList(response.data);
    setIsDoAttached(response.data.doSelected);
    if (response.status === 200 && response.data.length < 1) {
      setError(true);
      setTitle('Donnée inexistante');
      setErrorMessage(
        'Nous ne pouvons pas afficher la donnée car elle est inexistante'
      );
    }
  } catch (e) {
    setError(true);
  }
  setLoading(false);
};

export const hideShowSlides = (
  showRain: boolean,
  showEcp: boolean,
  showIli: boolean,
  showScoringGrid: boolean,
) => {
  const cssIds = ['pluie', 'ecp', 'ili', 'scoring-grid'];
  const hooksStates = [showRain, showEcp, showIli, showScoringGrid];
  let updateCssClassName: string[] = [];
  cssIds.forEach((id: string, index: number) => {
    updateCssClassName.push(className(id, hooksStates[index]));
  });
  return updateCssClassName;
};

// create new className for hide or show slides
export const className = (pSlide: string, pState: boolean) => {
  let classname: string = '';
  if (pState === true) {
    classname = 'vue-' + pSlide;
  } else {
    classname = 'hide-vue-' + pSlide;
  }
  return classname;
};
